import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="bg-gradient-custom min-h-screen flex flex-col items-center justify-center text-white font-sans px-4">
      <h1 className="text-8xl font-bold mb-2 text-white/90">404</h1>
      <p className="text-xl mb-6 text-white/80">
        Page not found
      </p>
      <p className="text-white/70 mb-8 text-center max-w-md">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <Link
        to="/loginregister"
        className="px-6 py-3 rounded-lg bg-white/20 hover:bg-white/30 text-white font-medium transition-colors border border-white/30"
      >
        Go to sign in
      </Link>
    </div>
  );
};

export default NotFound;
